module.exports = __webpack_public_path__ + "resources/img/img_maxgauge4_m.dff60c811daee494f4b3b776e34b8983.png";